import { symbols } from "./symbols.config";

export const slotConfig = {
    bets: [0.05, 0.25, 0.5, 1, 2, 2.5, 5, 7.5, 10, 25, 50, 100],
    columns: 5,
    rows: 5,
    symbols,
    betsLadder: [
        { "bet": 1, "coinValue": 0.01, "totalBet": 0.20 },
        { "bet": 2, "coinValue": 0.01, "totalBet": 0.40 },
        { "bet": 3, "coinValue": 0.01, "totalBet": 0.60 },
        { "bet": 4, "coinValue": 0.01, "totalBet": 0.80 },
        { "bet": 5, "coinValue": 0.01, "totalBet": 1.00 },
        { "bet": 6, "coinValue": 0.01, "totalBet": 1.20 },
        { "bet": 7, "coinValue": 0.01, "totalBet": 1.40 },
        { "bet": 8, "coinValue": 0.01, "totalBet": 1.60 },
        { "bet": 9, "coinValue": 0.01, "totalBet": 1.80 },
        { "bet": 10, "coinValue": 0.01, "totalBet": 2.00 },

        { "bet": 1, "coinValue": 0.02, "totalBet": 0.40 },
        { "bet": 2, "coinValue": 0.02, "totalBet": 0.80 },
        { "bet": 3, "coinValue": 0.02, "totalBet": 1.20 },
        { "bet": 4, "coinValue": 0.02, "totalBet": 1.60 },
        { "bet": 5, "coinValue": 0.02, "totalBet": 2.00 },
        { "bet": 6, "coinValue": 0.02, "totalBet": 2.40 },
        { "bet": 7, "coinValue": 0.02, "totalBet": 2.80 },
        { "bet": 8, "coinValue": 0.02, "totalBet": 3.20 },
        { "bet": 9, "coinValue": 0.02, "totalBet": 3.60 },
        { "bet": 10, "coinValue": 0.02, "totalBet": 4.00 },

        { "bet": 1, "coinValue": 0.05, "totalBet": 1.00 },
        { "bet": 2, "coinValue": 0.05, "totalBet": 2.00 },
        { "bet": 3, "coinValue": 0.05, "totalBet": 3.00 },
        { "bet": 4, "coinValue": 0.05, "totalBet": 4.00 },
        { "bet": 5, "coinValue": 0.05, "totalBet": 5.00 },
        { "bet": 6, "coinValue": 0.05, "totalBet": 6.00 },
        { "bet": 7, "coinValue": 0.05, "totalBet": 7.00 },
        { "bet": 8, "coinValue": 0.05, "totalBet": 8.00 },
        { "bet": 9, "coinValue": 0.05, "totalBet": 9.00 },
        { "bet": 10, "coinValue": 0.05, "totalBet": 10.00 },

        { "bet": 1, "coinValue": 0.10, "totalBet": 2.00 },
        { "bet": 2, "coinValue": 0.10, "totalBet": 4.00 },
        { "bet": 3, "coinValue": 0.10, "totalBet": 6.00 },
        { "bet": 4, "coinValue": 0.10, "totalBet": 8.00 },
        { "bet": 5, "coinValue": 0.10, "totalBet": 10.00 },
        { "bet": 6, "coinValue": 0.10, "totalBet": 12.00 },
        { "bet": 7, "coinValue": 0.10, "totalBet": 14.00 },
        { "bet": 8, "coinValue": 0.10, "totalBet": 16.00 },
        { "bet": 9, "coinValue": 0.10, "totalBet": 18.00 },
        { "bet": 10, "coinValue": 0.10, "totalBet": 20.00 },

        { "bet": 1, "coinValue": 0.20, "totalBet": 4.00 },
        { "bet": 2, "coinValue": 0.20, "totalBet": 8.00 },
        { "bet": 3, "coinValue": 0.20, "totalBet": 12.00 },
        { "bet": 4, "coinValue": 0.20, "totalBet": 16.00 },
        { "bet": 5, "coinValue": 0.20, "totalBet": 20.00 },
        { "bet": 6, "coinValue": 0.20, "totalBet": 24.00 },
        { "bet": 7, "coinValue": 0.20, "totalBet": 28.00 },
        { "bet": 8, "coinValue": 0.20, "totalBet": 32.00 },
        { "bet": 9, "coinValue": 0.20, "totalBet": 36.00 },
        { "bet": 10, "coinValue": 0.20, "totalBet": 40.00 },

        { "bet": 1, "coinValue": 0.50, "totalBet": 10.00 },
        { "bet": 2, "coinValue": 0.50, "totalBet": 20.00 },
        { "bet": 3, "coinValue": 0.50, "totalBet": 30.00 },
        { "bet": 4, "coinValue": 0.50, "totalBet": 40.00 },
        { "bet": 5, "coinValue": 0.50, "totalBet": 50.00 },
        { "bet": 6, "coinValue": 0.50, "totalBet": 60.00 },
        { "bet": 7, "coinValue": 0.50, "totalBet": 70.00 },
        { "bet": 8, "coinValue": 0.50, "totalBet": 80.00 },
        { "bet": 9, "coinValue": 0.50, "totalBet": 90.00 },
        { "bet": 10, "coinValue": 0.50, "totalBet": 100.00 }
      ]
};
